import React from 'react';
import FivepaisaLogo from '../../../../assets/img/landing/5paisa-logo.svg';
import aliceblueLogo from '../../../../assets/img/landing/aliceblue-logo.webp';
import jainamDuck from '../../../../assets/img/landing/duck-logo.svg';
import angelOneLogo from '../../../../assets/img/landing/angelone-logo.png';
import dhanLogo from '../../../../assets/img/landing/dhan-logo.svg';
import flatTradeLogo from '../../../../assets/img/landing/flattrade-logo.png';
import fyersLogo from '../../../../assets/img/landing/fyers-logo.svg';
import icicidirectLogo from '../../../../assets/img/landing/icicidirect-logo.svg';
import shoonyaLogo from '../../../../assets/img/landing/shoonya-logo.webp';
import upstoxLogo from '../../../../assets/img/landing/upstox-logo.svg';
import zerodhaLogo from '../../../../assets/img/landing/zerodha-logo.svg';
import xtsLogo from '../../../../assets/img/landing/xts.png';
import growwLogo from '../../../../assets/img/landing/groww_logo.webp';
import arrowLogo from '../../../../assets/img/landing/arrow.svg';
import './Integration.scss';

const Integration = () => {
  const partners = [
    {
      name: "Aliceblue",
      logo: aliceblueLogo
    },
    {
      name: "Angel One",
      logo: angelOneLogo
    },
    {
      name: "Dhan",
      logo: dhanLogo
    },
    {
      name: "Flattrade",
      logo: flatTradeLogo
    },
    {
      name: "Fyers",
      logo: fyersLogo
    },
    {
      name: "ICICIDirect",
      logo: icicidirectLogo
    },
    {
      name: 'JainamDuck',
      logo: jainamDuck
    },
    {
      name: "Shoonya",
      logo: shoonyaLogo
    },
    {
      name: "Upstox",
      logo: upstoxLogo
    },
    {
      name: "Zerodha",
      logo: zerodhaLogo
    },
    {
      name: "5paisa",
      logo: FivepaisaLogo
    },
    {
      name: "XTS",
      logo: xtsLogo
    },
    {
      name: "Groww",
      logo: growwLogo
    },
    {
      name: "Arrow",
      logo: arrowLogo
    },
    {
      name: "More Brokers",
      text: "200+ Brokers"
    }
  ];

  return (
    <div className="integration">
      <h2 className="title">
        Integrates with leading brokers
      </h2>
      <div className="marquee-container">
        <div className="marquee-content primary">
          {partners?.map((partner, index) => (
            <div
              key={index}
              className="partner-card"
            >
              {partner.logo ? (
                <img
                  src={partner.logo}
                  alt={partner.name}
                />
              ) : (
                <span className="partner-text">{partner.text}</span>
              )}
            </div>
          ))}
        </div>
        <div className="marquee-content secondary">
          {partners?.map((partner, index) => (
            <div
              key={index}
              className="partner-card"
            >
              {partner.logo ? (
                <img
                  src={partner.logo}
                  alt={partner.name}
                />
              ) : (
                <span className="partner-text">{partner.text}</span>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="mobile-grid">
        {partners?.map((partner, index) => (
          <div
            key={index}
            className="partner-card"
          >
            {partner.logo ? (
              <img
                src={partner.logo}
                alt={partner.name}
              />
            ) : (
              <span className="partner-text">{partner.text}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Integration;